import { trackSelfDescribingEvent } from "@snowplow/browser-tracker";
export function emitSearch(event) {
  event.snowplowContexts.forEach(function (snowplowEvent) {
    return trackSelfDescribingEvent({
      event: snowplowEvent
    });
  });
}